import {req, reqJson} from './axiosFun';

/**
 * 优惠券管理
 **/
// 获取列表
export const couponPage = (params) => {
  return reqJson("post", "/api/coupon/page", params)
};
//轮播图保存
export const couponSave = (params) => {
  return reqJson("post", "/api/coupon/save", params)
};
//轮播图删除
export const couponDelete = (params) => {
  return reqJson("post", "/api/coupon/delete/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/couponMG.js